const checkoutMenu = [ 
 'Product', 
 'Description', 
 'Quantity', 
 'Price', 
 'Remove' 
]

export default checkoutMenu;